import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userContextReducer from '../slices/user-context';
import categoryReducer from '../slices/category';
import cookieContextReducer from '../slices/cookie-context';

export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  reducer: {
    userContext: userContextReducer,
    category: categoryReducer,
    cookieContext: cookieContextReducer,
  },
});

export default store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
